document.addEventListener("DOMContentLoaded", () => {

  /* --------------------------------------------------------
     GENERIC ACCORDION TOGGLER
     Works for both .zeepy-accordion and .faq-container
  -------------------------------------------------------- */

  function setupAccordion(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const items = container.querySelectorAll(".faq-item");

    items.forEach(item => {
      const question = item.querySelector(".faq-question");
      if (!question) return;

      question.addEventListener("click", () => {

        const isOpen = item.hasAttribute("open");

        // Close all siblings first if you want exclusive expand
        items.forEach(i => i.removeAttribute("open"));

        // Toggle this one
        if (!isOpen) {
          item.setAttribute("open", "");
        }
      });
    });
  }

  /* Apply to both accordions */
  setupAccordion(".zeepy-accordion");
  setupAccordion(".faq-container");

});
